import { useAuthStore } from '../store/authStore';
import { mapBackendUserToApp } from './authUser';
import type { User } from '../types';

export const TEST_AUTH_TOKEN = 'roman-faceit-test-guest';

export const isTestLoginEnabled = process.env.REACT_APP_ENABLE_TEST_LOGIN !== 'false';

export function isTestAuthToken(token: string | null): boolean {
  return token === TEST_AUTH_TOKEN;
}

export function createTestGuestUser(): User {
  return mapBackendUserToApp(
    {
      id: 'test-guest',
      username: 'TestPlayer',
      email: 'test@guest.local',
      elo: 1500,
      isPremium: false,
      isAdmin: false,
    },
    {
      totalMatches: 42,
      wins: 24,
      losses: 18,
      winRate: 57.1,
      kd: 1.15,
    }
  );
}

export function setTestGuestSession(): void {
  localStorage.setItem('auth-token', TEST_AUTH_TOKEN);
}

export function loginAsTestGuest(): User {
  const user = createTestGuestUser();
  setTestGuestSession();
  useAuthStore.getState().login(user);
  return user;
}

export function restoreTestGuestSession(): void {
  const { user, isAuthenticated } = useAuthStore.getState();
  if (isAuthenticated && user) {
    return;
  }
  loginAsTestGuest();
}
